export default __webpack_public_path__ + "images/engineering-hover.svg";